// src/components/StoreLanding.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Button, Box, Grid, Paper, Stack } from '@mui/material';
import { alpha } from '@mui/material/styles';

export default function StoreLanding() {
    const navigate = useNavigate();
    const STORES = ['beta-store'];

    return (
        <Box
            sx={(theme) => ({
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: theme.spacing(6, 2),
                background:
                    theme.palette.background.ownerPage
                    || (theme.palette.mode === 'light'
                        ? 'radial-gradient(circle at 20% 20%, rgba(62,172,253,0.18), transparent 52%), linear-gradient(180deg, rgba(250,251,255,0.95) 0%, rgba(237,239,247,0.85) 100%)'
                        : 'radial-gradient(circle at 20% 20%, rgba(62,172,253,0.18), transparent 52%), linear-gradient(180deg, rgba(0,0,0,0.95) 0%, rgba(30,30,36,0.88) 100%)'),
            })}
        >
            <Container maxWidth='md'>
                <Paper
                    elevation={0}
                    sx={(theme) => ({
                        p: { xs: 4, md: 6 },
                        borderRadius: 4,
                        background:
                            theme.palette.background.ownerCard
                            || (theme.palette.mode === 'light'
                                ? 'linear-gradient(135deg, rgba(255,255,255,0.98) 0%, rgba(237,239,247,0.92) 100%)'
                                : 'linear-gradient(135deg, rgba(30,30,36,0.94) 0%, rgba(64,66,77,0.9) 100%)'),
                        border: `1px solid ${alpha(theme.palette.primary.main, theme.palette.mode === 'light' ? 0.1 : 0.2)}`,
                        boxShadow: '0 30px 60px rgba(62,172,253,0.16)',
                    })}
                >
                    <Stack spacing={3} textAlign='center' alignItems='center'>
                        <Stack spacing={1}>
                            <Typography variant='overline' color='primary.onSurface' sx={{ letterSpacing: '0.18em' }}>
                                Sortswift Kiosk
                            </Typography>
                            <Typography variant='h4' fontWeight={700} letterSpacing='-0.02em'>
                                Select your showcase location
                            </Typography>
                            <Typography variant='body1' color='text.secondary' maxWidth={520} sx={{ mx: 'auto' }}>
                                Choose the store experience you want to activate. Each destination is tailored with curated inventory, pricing, and checkout flows for your staff.
                            </Typography>
                        </Stack>

                        <Grid container spacing={3} justifyContent='center'>
                            {STORES.map((store) => (
                                <Grid item xs={12} sm={6} key={store}>
                                    <Paper
                                        elevation={0}
                                        sx={(theme) => ({
                                            p: 3,
                                            borderRadius: 3,
                                            height: '100%',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            gap: 2,
                                            background:
                                                theme.palette.background.ownerCard
                                                || (theme.palette.mode === 'light'
                                                    ? 'linear-gradient(145deg, rgba(255,255,255,0.98) 0%, rgba(237,239,247,0.94) 100%)'
                                                    : 'linear-gradient(145deg, rgba(30,30,36,0.92) 0%, rgba(64,66,77,0.9) 100%)'),
                                            border: `1px solid ${alpha(theme.palette.primary.main, theme.palette.mode === 'light' ? 0.1 : 0.24)}`,
                                        })}
                                    >
                                        <Typography variant='h6' fontWeight={600}>
                                            {store.replace(/-/g, ' ').toUpperCase()}
                                        </Typography>
                                        <Typography variant='body2' color='text.secondary'>
                                            Launch the kiosk experience tailored to this location.
                                        </Typography>
                                        <Button variant='contained' size='large' onClick={() => navigate(`/${store}`)}>
                                            Enter store
                                        </Button>
                                    </Paper>
                                </Grid>
                            ))}
                        </Grid>
                    </Stack>
                </Paper>
            </Container>
        </Box>
    );
}
